import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'axios';

export const VendorSearchModal = ({ show, setShow, onSelect }) => {
  const [surname, setSurname] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [page, setPage] = useState(0);
  const pageSize = 5;

  const handleClose = () => {
    setShow(false);
    setResults([]);
    setPage(0);
  };

  const handleSearch = () => {
    setSearching(true);
    const data = {
      FirstName: firstName,
      SurnameOrOrganisation: surname,
      TelephoneNumber: telephone,
      EmailAddress: email,
      AddressTypeId: 2,
    };
    axios
      .post('/Address/Search', JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        const arr = Array.isArray(res.data) ? res.data : [];
        setResults(arr);
        setPage(0);
        if (arr.length === 0) {
          toast.info('No results found', { autoClose: 3000 });
        }
      })
      .catch(() => {
        setResults([]);
        toast.error('Error while searching', { autoClose: 3000 });
      })
      .finally(() => setSearching(false));
  };

  const handleSelect = (vendor) => {
    if (onSelect) {
      onSelect(vendor);
    }
    handleClose();
  };

  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Header closeButton onHide={handleClose}>
        <Modal.Title>
          <span className="font-weight-bold">Search Owner</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label className="form-label" htmlFor="vendorSurname">
            Surname/Organisation:
          </label>
          <input
            id="vendorSurname"
            autoComplete="off"
            className="form-control d-block w-100 mb-2"
            type="text"
            value={surname}
            onChange={(e) => setSurname(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="vendorFirstName">
            First Name:
          </label>
          <input
            id="vendorFirstName"
            autoComplete="off"
            className="form-control d-block w-100 mb-2"
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="vendorEmail">
            Email:
          </label>
          <input
            id="vendorEmail"
            autoComplete="off"
            className="form-control d-block w-100 mb-2"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="vendorTelephone">
            Telephone:
          </label>
          <input
            id="vendorTelephone"
            autoComplete="off"
            className="form-control d-block w-100 mb-2"
            type="text"
            value={telephone}
            onChange={(e) => setTelephone(e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-between mb-2">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSearch} disabled={searching}>
            {searching ? 'Searching...' : 'Search'}
          </Button>
        </div>
        {results.length > 0 && (
          <div className="mt-2">
            {results
              .slice(page * pageSize, page * pageSize + pageSize)
              .map((r, idx) => {
                const phone =
                  (r.addressPhones && r.addressPhones[0]?.telephoneNo) ||
                  r.telephoneNumber;
                const emailAddr =
                  (r.addressEmails && r.addressEmails[0]?.emailAddress) ||
                  r.emailAddress;
                return (
                  <div
                    key={idx}
                    className="border rounded p-2 mb-2"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(r)}
                  >
                    <p className="mb-0 font-weight-bold">
                    {r.addressFullName || `${r.firstName || ''} ${r.surnameOrOrganisation || ''}`}
                  </p>
                  {phone && (
                    <small className="d-block">Tel: {phone}</small>
                  )}
                  {emailAddr && <small className="d-block">{emailAddr}</small>}
                </div>
              );
            })}
            <div className="d-flex justify-content-between align-items-center mt-2">
              <Button
                variant="secondary"
                size="sm"
                disabled={page === 0}
                onClick={() => setPage((p) => Math.max(p - 1, 0))}
              >
                Prev
              </Button>
              <span>
                Page {page + 1} of {Math.ceil(results.length / pageSize)}
              </span>
              <Button
                variant="secondary"
                size="sm"
                disabled={(page + 1) * pageSize >= results.length}
                onClick={() =>
                  setPage((p) =>
                    (p + 1) * pageSize >= results.length ? p : p + 1,
                  )
                }
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
